export function getColor(color: string): string {
  return color.startsWith("--") ? `var(${color})` : color;
}
